import React, { Component } from "react";
import { CardCVCElement, CardExpiryElement, CardNumberElement, injectStripe } from 'react-stripe-elements';
import {convertReadbleFormat} from './../helpers';

const createOptions = () => {
  return {
    style: {
      base: {
        color: '#555',
        fontFamily: 'Open Sans, sans-serif',
        '::placeholder': {
    		  color: "#555",
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};

class Card extends Component {

  cardBrandToPfClass = {
    visa: 'pf-visa',
    mastercard: 'pf-mastercard',
    amex: 'pf-american-express',
    discover: 'pf-discover',
    diners: 'pf-diners',
    jcb: 'pf-jcb',
    unknown: 'pf-credit-card',
  };

  constructor(props) {
    super(props);
    this.state = {
        cardHolderName: '',
        isSubmit: false,
        isCardError: false,
    };
  }

  handleSubmit = () => {
    this.setState({
        isSubmit: true,
        isCardError: this.state.cardHolderName.length < 5 ? false : true
    });
  };

  handleChange = e => {
    const value = e.target.value;
    this.setState({
        cardHolderName: value,
        isCardError: value.length < 5 ? false : true
    })
  };

  clearFields = () => {
    this.setState({
      cardHolderName: '',
      isSubmit: false,
      isCardError: false,
    });
  }

  setBrandIcon(brand) {
    const brandIcon = this.props.brandIcon;
    const brandIconElement = document.getElementById(brandIcon);
    let pfClass = 'pf-credit-card';
    if (brand in this.cardBrandToPfClass) {
      pfClass = this.cardBrandToPfClass[brand];
    }
    for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  }

  handleCardChange = (event) => {
    if (event.brand) {
      this.setBrandIcon(event.brand);
    }
  }

  render() {

    const { cardHolderName, isSubmit } = this.state;

    const { isOtherCss } = this.props
   
    return (
        <div className="paymentCardDiv col-md-12" style={ isOtherCss ? {
          marginLeft: -15,
          width: '105%',
        } : {}}>
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="email">Card Number:</label>
                    <CardNumberElement
                    className="form-control card-input"
                    placeholder="XXXX XXXX XXXX XXXX"
                    onChange={this.handleCardChange}
                    {...createOptions()}
                    />
                    <span className="brand"><i className="pf pf-credit-card" id="brand-icon" /></span>
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="email">Card Expiration:</label>
                    <CardExpiryElement className="form-control card-input" />
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label htmlFor="email">CVC:</label>
                    <CardCVCElement className="form-control card-input" placeholder="***" />
                </div>
            </div>

            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="cardHolderName">Card Holder Name:</label>
                    <input
                    type="text"
                    className="form-control"
                    id="cardHolderName"
                    placeholder="Enter Card Holder Name"
                    name="cardHolderName"
                    onChange={this.handleChange}
                    required
                    value={cardHolderName}
                    />
                    {cardHolderName.length === 0 && isSubmit && (
                    <span className="error text-danger">
                        {convertReadbleFormat("cardHolderName field is required.")}
                    </span>
                    )}
                    {(cardHolderName.length > 0 && cardHolderName.length < 5 && isSubmit)  && (
                    <span className="error text-danger">
                        {convertReadbleFormat("cardHolderName field must be at least 5 characters.")}
                    </span>
                    )}
                </div>
            </div>

            <div className="col-md-6"></div>

            </div>
    );
  }
}

export default (injectStripe(Card, {
    withRef: true
}));



// WEBPACK FOOTER //
// ./src/modals/card.js